import { FlaskConical } from "lucide-react";
import { Switch } from "../ui/switch";
import { useScenarioMode } from "../../context/ScenarioModeContext";

// Build 7.5A — Scenario Mode controls. The toggle is the explicit user action that
// switches a company-dependent view between Official Forecast and Scenario Outcome.
// The banner makes scenario-adjusted numbers unmistakable (§29).

export function ScenarioToggle() {
  const { scenarioMode, setScenarioMode } = useScenarioMode();
  return (
    <label
      className={`flex items-center gap-2 px-3 h-9 rounded-md border text-sm font-medium cursor-pointer transition-colors ${
        scenarioMode ? "bg-[#FFF7ED] border-[#FDBA74] text-[#9A3412]" : "bg-white border-slate-200 text-slate-600 hover:text-slate-900"
      }`}
      data-testid="scenario-mode-toggle"
    >
      <FlaskConical className="h-4 w-4" />
      Scenario
      <Switch
        checked={scenarioMode}
        onCheckedChange={setScenarioMode}
        data-testid="scenario-mode-switch"
        aria-label="Toggle Scenario Mode"
      />
    </label>
  );
}

export function ScenarioBanner({ meta }) {
  const { scenarioMode } = useScenarioMode();
  if (!scenarioMode) return null;
  const count = meta?.active_count ?? 0;
  const names = meta?.names || [];
  return (
    <div
      className="mb-4 flex items-start gap-2 rounded-lg border border-[#FDBA74] bg-[#FFF7ED] p-3"
      data-testid="scenario-mode-banner"
    >
      <FlaskConical className="h-4 w-4 text-[#C2410C] shrink-0 mt-0.5" />
      <div>
        <div className="text-sm font-semibold text-[#9A3412]">
          SCENARIO MODE — {count} active scenario{count === 1 ? "" : "s"}
        </div>
        <div className="text-xs text-[#9A3412]/80 mt-0.5">
          {count === 0
            ? "Showing the Official Forecast — no active scenarios. Manage scenarios under Planning → Scenarios."
            : `Scenario Outcome = Official Forecast + ${names.join(", ")}. Official figures are unchanged.`}
        </div>
      </div>
    </div>
  );
}
